import { MiddlewareCreatorType, MiddlewareType } from '../relay-types';

export const buildRequestMiddleware: MiddlewareCreatorType = (): MiddlewareType => async (args, next) => {
    const { context, operation, variables } = args;
    context.url = 'unknown';
    context.request = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: operation.text,
            variables,
        }),
    };
    return next(args);
};
